<script lang="ts">

import {Modal} from "flowbite-svelte";
import {get} from "$lib/api";
import {ClockOutline, DnaOutline} from "flowbite-svelte-icons";
import dayjs from "dayjs";
export let open = false;
export let mailId = null;

let currentMailId = null;

let status:{ArrivedAt:string,Status:string,AttemptCount:number,UUID:string, SpamassassinScore: number}[]|null = null
$: {
    if(mailId && mailId !== currentMailId) {
        currentMailId = mailId
        get('/mail-retrieval/'+mailId).then(r => status = r)
    }
}
</script>
<Modal title="E-Mail Status" bind:open>
    {#if status}
        {#each status as status}
        <div class="grid grid-cols-2 gap-3">
            <div><ClockOutline/></div>
            <div>{dayjs(status.ArrivedAt).format('DD.MM.YYYY HH:mm')}</div>
            <div><DnaOutline/></div>
            <div class="uppercase font-bold">{status.Status}</div>
            <div>Spam-Score</div>
            <div>{status.SpamassassinScore}</div>
            <div>Versuche</div>
            <div>{status.AttemptCount + 1}</div>
        </div>
        {/each}
    {/if}
</Modal>